// externals
import { RSAA } from 'redux-api-middleware';

// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';

// consts/enums
import { DOC_UPLOAD_FETCH_REQUEST, DOC_UPLOAD_FETCH_FAILURE, DOC_UPLOAD_FETCH_SUCCESS } from '../actionTypes/docUploadActionTypes';

// utils
import { apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';
import { getDealRefId } from '../selectors/offerSelectors';

export const fetchDocUploadRSAA = (appPrefix: string, state: StateTree) => {
    const locHref = locHrefUtil.getLocHref();
    const fsDealRefId = getDealRefId(state);
    const referrer = 'CMD';

    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, '/docUploadV2');
    const leadRoutingOverrideSettingsEnabled = dealerSelectors.getLeadRoutingOverrideSettingsEnabled(state);
    const partnerId = dealerSelectors.getPartnerId(state);
    const partnerDealerId = dealerSelectors.getPartnerDealerId(state);
    const isDocUploadLambda = featureToggleSelectors.enableStatusLambdaSwitch(state);
    const mmdDealerId = leadRoutingOverrideSettingsEnabled
        ? dealerSelectors.getLeadOverrideDealerId(state)
        : dealerSelectors.getDealerId(state);
    const bffEndpoint = `${bffApiUrlResult.url}`;
    const dealerId = (partnerId !== 'MMD' && partnerDealerId) || mmdDealerId;

    if (isDocUploadLambda) {
        return {
            [RSAA]: {
                endpoint: `${bffEndpoint}/status`,
                method: 'POST',
                body: JSON.stringify({ partnerId, dealerId, fsDealRefId }),
                headers: {
                    'Content-Type': 'application/json',
                    'x-dr-referrer': referrer
                },
                types: [DOC_UPLOAD_FETCH_REQUEST, DOC_UPLOAD_FETCH_SUCCESS, DOC_UPLOAD_FETCH_FAILURE]
            }
        };
    }

    return {
        [RSAA]: {
            endpoint: `${bffEndpoint}/dealerId/${mmdDealerId}/dealRefId/${fsDealRefId}/statuses`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-dr-referrer': referrer
            },
            types: [DOC_UPLOAD_FETCH_REQUEST, DOC_UPLOAD_FETCH_SUCCESS, DOC_UPLOAD_FETCH_FAILURE]
        }
    };
};
